module.exports = __webpack_public_path__ + "static/media/thumbPMG.9df3bb48.webp";